import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./addressesPutActions";

export function request(action) {
  let { addressId, json, emulateFailure } = action;
  return requestWithSubTenantIfNeeded("put", `addresses/${addressId}`, {
    headers: emulateFailure ? { "x-end-with-fail": "true" } : {},
    json,
  });
}

function* addressesPut(action) {
  try {
    let response = yield call(request, action.payload);
    yield put(actions.requestSuccess(action.payload, response.data));

    if (action.resolve) {
      yield call(action.resolve);
    }
  } catch (error) {
    yield put(actions.requestFailure(action.payload, error));

    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.ADDRESSES_PUT_REQUEST, addressesPut);
}

export default saga;
